import { useLocation } from 'react-router-dom';

/** The page as an external flow should send the browser back to it: path and query, never the hash. */
export const useReturnPath = (): string => {
  const location = useLocation();
  return `${location.pathname}${location.search}`;
};
